import { NormalizeApi } from "../../normalizeApi";
const BASE_ACTIONS_ENDPOINT = 'authorization.actions';
export const AuthorizationApi = NormalizeApi({
  getUserRole: `${BASE_ACTIONS_ENDPOINT}.get-user-role`,
  getUsersRoles: `${BASE_ACTIONS_ENDPOINT}.get-users-roles`,
  setUserRole: `${BASE_ACTIONS_ENDPOINT}.set-user-role`
});